import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./Assigned.module.scss";
import { CheckIcon, CloseIcon, DeleteIcon, MinusIcon, PlusIcon } from "Assets/icons";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { convertToMomentDate, getGuardianOptionLabel, successMessageToast, userFullName } from "helpers/common";
import { APPOINTMENT_LIST } from "config/paths";
import { useNavigate } from "react-router-dom";
import { CommonMultiSelect, CommonSelect, CommonToolTip, CstmPagination, RequiredFieldAstrick } from "components/Common/Common";
import { useAssignAppointmentChatterMutation, useAssignAppointmentTherpaistMutation, useLazyGetAppointmentTherapistsQuery, useUnAssignAppointmentChatterMutation, useUnAssignAppointmentTherapistMutation } from "store/services/appointment";
import { useGetChatterProgramListQuery } from "store/services/chatter/program";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useState } from "react";
import { debounce } from "lodash";
import { FieldArray, Formik } from "formik";
import { validationTherapistSchema } from "pages/SideTabPages/Appointments/detail/therapistsSchema";
import AppInputField from "components/shared/FormComponents/AppInputField";
import TableHeader from "components/shared/FormComponents/TableHeader";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import moment from "moment";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { chatterProgramProfilesFilter } from "store/slices/filter";

const AssignTherapistAndChatterModal = ({ show, setShow, assessmentOptions, type, id, appointment }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const filter = useSelector(state => state?.filter?.chatterProgramProfilesFilter);
    const [currentChatter, setCurrentChatter] = useState(null)
    const [therapistOptions, setTherapistOptions] = useState([])
    const [currentAssignedTherapist, setCurrentAssignedTherapist] = useState(null)
    const [modalType, setModalType] = useState(null)
    const [showModal, setShowModal] = useState(false)

    const handlePopup = () => setShow(!show);


    const [getTherapists, { isFetching: therapistsLoading }] = useLazyGetAppointmentTherapistsQuery()
    const [assignTherapist, { isLoading: assignTherapistLoading }] = useAssignAppointmentTherpaistMutation()
    const [unAssignTherapist, { isLoading: unAssignTherapistLoading }] = useUnAssignAppointmentTherapistMutation()
    const { data: chatterData, isError: chatterError, isFetching } = useGetChatterProgramListQuery({ page: currentPage, limit: pageSize, ...filter });
    const totalRecords = chatterData?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const [assignChatter, { isLoading: assignChatterLoading }] = useAssignAppointmentChatterMutation()
    const [unAssignChatter, { isLoading: unAssignChatterLoading }] = useUnAssignAppointmentChatterMutation()

    const chattetColumn = [
        {
            head: "Program Name",
            accessor: "name",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-sbold">{item?.name || "--"}</h6>
            )
        },
        {
            head: "Start Date",
            accessor: "start_date",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <>{convertToMomentDate(item?.start_date)}</>
            )
        },
        {
            head: "End Date",
            accessor: "end_date",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <>{convertToMomentDate(item?.end_date)}</>
            )
        },
        {
            head: "Day",
            accessor: "day",
            sorter: true,
            component: (item, ind) => (
                <div className="text-capitalize">{item?.day || "--"}</div>
            )
        },
        {
            head: "Time",
            accessor: "time",
            sorter: true,
            component: (item, ind) => (
                <div>{item?.time ? moment(item?.time, "HH:mm:ss").format("hh:mm A") : "--"}</div>
            )
        },
        // {
        //     head: "Funding Source",
        //     accessor: "FundingSource",
        //     isComponent: true,
        //     component: (item, ind) => (
        //         <h6 className="m-0 fw-sbold">{item?.program_funding_source?.name || "--"}</h6>
        //     )
        // },
        {
            head: "Location",
            accessor: "location",
            sorter: true,
        },
        {
            head: "Location Type",
            accessor: "location_type",
            sorter: true,
        },
        {
            head: "Status",
            accessor: "status",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <p
                    style={{ width: 80 }}
                    className={`${item.status == "active"
                        ? "greenStatus"
                        : "redStatus"
                        } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {item.status}
                </p>
            ),
        },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">

                    {/* <CommonToolTip
                 text={"Archive"}
                 component={<Button
                   className="p-0"
                   variant="transparent"
                   type="button"
                   onClick={(e) => {
                     e.stopPropagation();
 
                     if (!isFetching) {
 
                     //   setModalType(item?.status == "active" ? "archive" : "active");
                     //   setCurrentEntry(item);
                     //   setShowModal(true);
                     }
                   }}
                 >
                   {item?.status == "active" ? <ArchiveIcon /> : <UnArchiveIcon />}
                 </Button>}
               />  */}
                    <CommonToolTip
                        text={"Assign Chatter"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={(e) => {

                                e.stopPropagation()
                                setModalType('assignChatter')
                                setCurrentChatter(item)
                                setShowModal(true)
                            }}
                        >
                            <CheckIcon />
                        </Button>}
                    />
                    {/* <CommonToolTip
                         text={"Delete"}
                         component={<Button
                             className="p-0"
                             variant="transparent"
                             type="button"
                             onClick={(e) => {
 
                                 e.stopPropagation()
                                 // setModalType("delete");
                                 // setCurrentEntry(item);
                                 // setShowModal(true);
                             }}
                         >
                             <DeleteIcon />
                         </Button>}
                     /> */}
                </div>
            ),
        },
    ];


    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handleFilterChange = (key) => (value) => {
        dispatch(chatterProgramProfilesFilter({ ...filter, [key]: value }))
        setCurrentPage(1);
    };

    const resetFilter = () => {
        dispatch(chatterProgramProfilesFilter({ search: "", status: "active", sort: { column: "name", direction: "asc" } }));
        setCurrentPage(1)
    };

    const getTherapistLookup = async (search, type) => {
        try {

            let result = null;
            const body = {
                search,
                limit: 20
            }

            result = await getTherapists({ body }).unwrap();


            if (!result?.records?.length) {
                return;
            }

            const therapistList = result?.records?.map((item) => ({ value: item.id, label: getGuardianOptionLabel(item), ...item }));
            console.log("THERAPIST LABEL ", therapistList)
            setTherapistOptions(therapistList)

        } catch (err) {
            console.error("error fetching therapists", err)
        };
    };

    const handleSearch = useCallback(debounce((search = "", type) => {
        if (search) getTherapistLookup(search, type);
        else {
            setTherapistOptions([]);
        }
    }, 500), []);

    const handleTherpaistSubmit = async (values, actions) => {

        const body = {
            appointment_id: id,
            client_id: appointment?.record?.client_id,
            guardian_id: appointment?.record?.guardian_id,
            admin_id: appointment?.record?.admin_id,
            therapistsService: values?.therapists?.map((item) => ({ therapist_id: item?.id, service: item?.service?.length > 0 ? item?.service?.map((data) => data?.value) : [] }))
            // "appointment_status": "pending",
            // "appointment_dates": {
            //     "start": "",
            //     "end": ""
            // },
            // "calenderly_link": "",
            // "notification_status": "pending",
        }

        try {
            const data = await assignTherapist({ body }).unwrap()
            successMessageToast(data?.message)
            handlePopup()
            actions?.resetForm()
        } catch (error) {
            console.log("Error assigning therapists: ", error)
        }
    }

    const handleUnAssignTherapist = async () => {
        setShowModal(false)
        try {
            await unAssignTherapist({ id: currentAssignedTherapist?.id }).unwrap()
        } catch (error) {
            console.log("error unassigning therpaist", error)
        }
    }

    const handleAssignChatter = async () => {
        setShowModal(false)
        const body = {
            appointment_id: appointment?.record?.id,
            program_id: currentChatter?.id,
            client_id: appointment?.record?.client_id
        }
        try {
            const result = await assignChatter({ body }).unwrap()
            successMessageToast(result.message)
            console.log('result', result)
        } catch (error) {
            console.log("error unassigning therpaist", error)
        }
    }

    const handleUnAssignChatter = async () => {
        setShowModal(false)
        const body = {
            appointment_id: appointment?.record?.id,
            program_id: currentChatter?.program_id,
            client_id: appointment?.record?.client_id
        }
        try {
            const result = await unAssignChatter({ body }).unwrap()
            successMessageToast(result.message)
        } catch (error) {
            console.log("error unassigning all therpaists", error)
        }
    }
    const isLoading = false
    const isError = false
    return (
        <>
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={modalType == "assignChatter" && handleAssignChatter}
                type={modalType}
            />
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="xl"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 15, top: 5 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div className="d-flex justify-content-center gap-2 align-items-center">
                        <h5 className="m-0 fw-bold themeBlue my-2">{`Assign ${type ? "Therapist" : "Chatter"}`} </h5>
                    </div>
                    <hr></hr>
                    <Row className="">
                        {
                            type ?
                                <>
                                    {/* <Col lg="12" className="">
                                        <div className="top d-flex justify-content-between align-items-center">
                                            <h6 className="m-0 fw-bold pb-2">Assigned Therapists</h6>
                                            <Button
                                                type="button"
                                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                disabled={unAssignAllTherapistsLoading}
                                                onClick={() => {
                                                    setModalType("unassignAll")
                                                    setShowModal(true)
                                                }}
                                            >
                                                {unAssignAllTherapistsLoading ? <LoadingIndicator color='#fff' inline /> : "Assign therapist"}
                                            </Button>
                                        </div>
                                    </Col> */}

                                    <Col lg="12" className="my-3">
                                        {/* <h6 className="m-0 themeBlue fw-sbold">Consent Forms: </h6> */}
                                        {/* <p className="m-0 forteen themeBlue">
        {lessonDetails?.description || "--"}
    </p> */}
                                        {/* <div className="table-outer">
                                            {assignedTherapistListLoading ? (
                                                <div style={{ height: "200px" }}>
                                                    <LoadingIndicator />
                                                </div>
                                            ) : isError ? (
                                                <ErrorComponent />
                                            ) : (
                                                <>
                                                    {(assignedTherapistListLoading) && (
                                                        <LoadingOverlay />
                                                    )}
                                                    <TableLayout data={assignedTherapistList} column={therapistColumn} />
                                                </>
                                            )}
                                        </div> */}
                                    </Col>
                                    <Col lg="12" className="my-1">
                                        <div className="top pb-3 d-flex justify-content-between align-items-center">
                                            <h6 className="m-0 fw-bold pb-2">Assign New Therapists</h6>
                                        </div>
                                    </Col>

                                    <Col lg="12" className="">
                                        <Formik
                                            initialValues={{
                                                therapists: [{ lastname: "", firstname: "", email: "", service: "", id: "" }]
                                            }}
                                            validationSchema={validationTherapistSchema}
                                            onSubmit={handleTherpaistSubmit}
                                            enableReinitialize
                                        >
                                            {({
                                                handleSubmit, values, setFieldValue
                                            }) => (
                                                <Form onSubmit={handleSubmit}>
                                                    <div
                                                        className=""
                                                    //   style={{ borderTop: "1px solid #41a2a84d" }}
                                                    >
                                                        <Row>
                                                            <Col lg="12">
                                                                <FieldArray name="therapists">
                                                                    {({ insert, remove, push }) => (
                                                                        <ul className="list-unstyled ps-0 mb-0">
                                                                            {values.therapists.length > 0 &&
                                                                                values.therapists.map((area, index) => {
                                                                                    let isLastItem = index === values.therapists.length - 1;
                                                                                    return (
                                                                                        <Row className="align-items-center" key={index}>
                                                                                            <Col lg="10">
                                                                                                <Row>
                                                                                                    <Col md="3" sm="6" className="my-2">
                                                                                                        <label
                                                                                                            htmlFor=""
                                                                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                                                        >
                                                                                                            Last Name
                                                                                                            <RequiredFieldAstrick />
                                                                                                        </label>
                                                                                                        <CommonSelect
                                                                                                            placeholder={"Select Therapist"}
                                                                                                            isClearable
                                                                                                            name={`values?.therapists?.[${index}]?.lastname`}
                                                                                                            handleBlur={() => setTherapistOptions([])}
                                                                                                            // creatable={true}
                                                                                                            onInputChange={(e) => handleSearch(e, "parents}")}
                                                                                                            option={therapistOptions}
                                                                                                            isLoading={therapistsLoading}
                                                                                                            value={values?.therapists?.[index]?.lastname && { label: values?.therapists?.[index]?.lastname, value: values?.therapists?.[index]?.lastname }}
                                                                                                            onChange={(selected) => {
                                                                                                                let therapist = therapistOptions?.find(therapist => therapist.id === selected?.value);
                                                                                                                let selectedValue = {
                                                                                                                    ...selected,
                                                                                                                    label: therapist?.lastname
                                                                                                                };
                                                                                                                if (!therapist) {
                                                                                                                    // setClientOptions([])
                                                                                                                    setFieldValue(`therapists.${index}.lastname`, selected);
                                                                                                                    setFieldValue(`therapists.${index}.id`, null);
                                                                                                                    setFieldValue(`therapists.${index}.firstname`, "");
                                                                                                                    setFieldValue(`therapists.${index}.email`, "");
                                                                                                                    setFieldValue(`therapists.${index}.phone`, "");
                                                                                                                    // setFieldValue('clientType', "")
                                                                                                                    // setFieldValue('clientId', "")
                                                                                                                    // setConsentFormOptions([]);
                                                                                                                    // setFieldValue("consentForms", []);

                                                                                                                    return;
                                                                                                                }
                                                                                                                setFieldValue(`therapists.${index}.lastname`, therapist.lastname);
                                                                                                                setFieldValue(`therapists.${index}.id`, selectedValue.id);
                                                                                                                setFieldValue(`therapists.${index}.firstname`, therapist?.firstname);
                                                                                                                setFieldValue(`therapists.${index}.email`, therapist?.email);
                                                                                                                setFieldValue(`therapists.${index}.phone`, therapist?.phone);
                                                                                                                // setFieldValue('clientType', "")
                                                                                                                // setFieldValue('clientId', "")
                                                                                                                setTherapistOptions([])
                                                                                                                // setConsentFormOptions([]);
                                                                                                                // setFieldValue("consentForms", []);
                                                                                                            }}
                                                                                                        />
                                                                                                    </Col>
                                                                                                    <Col md="3" sm="6" className="my-2">
                                                                                                        <label
                                                                                                            htmlFor=""
                                                                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                                                        >
                                                                                                            First Name
                                                                                                            <RequiredFieldAstrick />
                                                                                                        </label>
                                                                                                        <AppInputField
                                                                                                            disabled={!!area?.id}
                                                                                                            name={`therapists.${index}.firstname`}
                                                                                                            placeholder="e.g John Smith"
                                                                                                            className={`${styles.formControl} form-control`}
                                                                                                        />
                                                                                                    </Col>

                                                                                                    <Col md="3" sm="6" className="my-2">
                                                                                                        <label
                                                                                                            htmlFor=""
                                                                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                                                        >
                                                                                                            Email
                                                                                                            <RequiredFieldAstrick />
                                                                                                        </label>
                                                                                                        <AppInputField
                                                                                                            disabled={!!area?.id}
                                                                                                            name={`therapists.${index}.email`}
                                                                                                            placeholder="John@gmail.com"
                                                                                                            className={`${styles.formControl} form-control`}
                                                                                                        />
                                                                                                    </Col>
                                                                                                    <Col md="3" sm="4">
                                                                                                        <label className="form-label fw-bold themeBlue d-flex">
                                                                                                            Service
                                                                                                            <RequiredFieldAstrick />
                                                                                                        </label>
                                                                                                        <CommonMultiSelect
                                                                                                            name={`therapists.${index}.service`}
                                                                                                            option={assessmentOptions}
                                                                                                            placeholder={"Select Service"}
                                                                                                        // onChange={(val) => {
                                                                                                        //   setClientOptions([]);
                                                                                                        //   getClientOptions(val);
                                                                                                        //   setValues({
                                                                                                        //     ...values,
                                                                                                        //     client_type: val,
                                                                                                        //     client_id: ""
                                                                                                        //   })
                                                                                                        // }}
                                                                                                        />
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Col>
                                                                                            <Col lg="2">
                                                                                                <Button
                                                                                                    className="border-0 p-0"
                                                                                                    variant="transparnet"
                                                                                                >
                                                                                                    {isLastItem ? (

                                                                                                        values.therapists.length > 1 ? (
                                                                                                            <>
                                                                                                                <PlusIcon onClick={() => push({ ...singleParent })} />
                                                                                                                <MinusIcon onClick={() => {
                                                                                                                    // if (area.id && parents.includes(area.id)) {
                                                                                                                    //     setCurrentEntry({ ...area, setFieldValue, list: values?.parents });
                                                                                                                    //     setShowModal(true);
                                                                                                                    //     return;
                                                                                                                    // }
                                                                                                                    remove(index)
                                                                                                                }} />
                                                                                                            </>
                                                                                                        ) : <PlusIcon onClick={() => push({ ...singleParent })} />

                                                                                                    ) : <MinusIcon onClick={() => {
                                                                                                        // if (area.id && parents.includes(area.id)) {
                                                                                                        //     setCurrentEntry({ ...area, setFieldValue, list: values?.parents });
                                                                                                        //     setShowModal(true);
                                                                                                        //     return;
                                                                                                        // }
                                                                                                        remove(index)
                                                                                                    }} />
                                                                                                    }
                                                                                                </Button>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    )
                                                                                })}
                                                                        </ul>
                                                                    )}
                                                                </FieldArray>
                                                            </Col>
                                                            <Col lg="2" className="my-2">
                                                                <div className='mt-5'>
                                                                    {/* {errorMessage && <div className='my-2 error'>{errorMessage}</div>} */}
                                                                    <Button
                                                                        type="submit"
                                                                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                    // disabled={appointment?.record?.payment_status != "success" && appointment?.record?.appointment_type == "paid"}
                                                                    // disabled={isSubmitted || saveFormLoading}
                                                                    // onClick={() => updatePrice()}
                                                                    >
                                                                        {assignTherapistLoading ? <LoadingIndicator color='#fff' inline /> : "Assign"}
                                                                    </Button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Form>)}
                                        </Formik>
                                    </Col>
                                </>
                                :
                                <>
                                    {/* <Col lg="12" className="">
                                        <div className="top d-flex justify-content-between align-items-center">
                                            <h6 className="m-0 fw-bold pb-2">Assigned Chatter Programs</h6>
                                            <Button
                                                                        type="button"
                                                                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                        disabled={unAssignAllTherapistsLoading}
                                                                        onClick={() => {
                                                                            setModalType("unassignAll")
                                                                            setShowModal(true)
                                                                        }}
                                                                    >
                                                                        {unAssignAllTherapistsLoading ? <LoadingIndicator color='#fff' inline /> : "Unassign All"}
                                                                    </Button>
                                        </div>
                                    </Col> */}

                                    <Col lg="12" className="my-3">
                                        {/* <h6 className="m-0 themeBlue fw-sbold">Consent Forms: </h6> */}
                                        {/* <p className="m-0 forteen themeBlue">
                                                                    {lessonDetails?.description || "--"}
                                                                </p> */}
                                        {/* <div className="table-outer">
                                            {assignChatterListLoading ? (
                                                <div style={{ height: "200px" }}>
                                                    <LoadingIndicator />
                                                </div>
                                            ) : isError ? (
                                                <ErrorComponent />
                                            ) : (
                                                <>
                                                    {(assignChatterListLoading) && (
                                                        <LoadingOverlay />
                                                    )}
                                                    <TableLayout data={assignedChatterList?.chatterAssignedList} column={assignedChattersColumn} />
                                                </>
                                            )}
                                        </div> */}
                                    </Col>

                                    <Col lg="12">
                                        <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                            <div className="left">
                                                <TableHeader
                                                    heading={"Chatter Program Profiles"}
                                                    handleFilterChange={handleFilterChange}
                                                    resetFilter={resetFilter}
                                                    filter={filter}
                                                    searchPlaceholder="Program Name"
                                                />
                                            </div>
                                            <div className="table-outer">
                                                {isLoading ? (
                                                    <div style={{ height: "200px" }}>
                                                        <LoadingIndicator />
                                                    </div>
                                                ) : isError ? (
                                                    <ErrorComponent />
                                                ) : (
                                                    <>
                                                        {(isFetching) && <LoadingOverlay />}
                                                        <TableLayout
                                                            data={chatterData?.lessons}
                                                            column={chattetColumn}
                                                            url={"/manage-chatter/program-profiles/detail"}
                                                            filter={filter}
                                                            handleSort={handleFilterChange("sort")}
                                                        />
                                                    </>
                                                )}
                                                <CstmPagination
                                                    totalPages={totalPages}
                                                    activePage={currentPage}
                                                    handlePageChange={handlePageChange}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </>
                        }


                    </Row>
                    {/* <Row>
                        <Col md="12" className="mt-3">
                            <div className="d-flex align-items-center justify-content-center">
                                <Button
                                    type="button"
                                    className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                    onClick={() => navigate(APPOINTMENT_LIST)}
                                >
                                    OK
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                </Modal.Body>
            </Modal >
        </>
    );
};

const singleParent = {
    firstname: "",
    lastname: "",
    phone: "",
    email: ""
}

export default AssignTherapistAndChatterModal;